import { LabelsContainer } from "./LabelsContainer.styled";
import { Typography } from "@ann/web-components";

const LabelsContainerComponent = () => {
  return (
    <LabelsContainer>
      <Typography category="subtitle" size="medium" weight="bold">
        Build, configure, and test your prompt
      </Typography>
    </LabelsContainer>
  );
};

export default LabelsContainerComponent;
